<template>
  <div>
    <wc-section-title title='Settings'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'settings-base',
  computed: {
    menu () {
      return [
        {
          title: 'Settings Dashboard',
          icon: this.$store.state.icons.modules.settings.icon,
          route: { name: 'SettingsDashboard' }
        },
        {
          title: 'Divisions',
          icon: this.$store.state.icons.dataBox.divisions.icon,
          route: { name: 'Divisions' }
        },
        {
          title: 'Email Log',
          icon: 'mdi-email-outline',
          route: { name: 'EmailLog' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Settings Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
